import React from 'react';
import './footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer__container container">
        <h1 className="footer__title">Sony</h1>

        <ul className="footer__list">
          <li>
            <a href="#about" className="footer__link">
              About
            </a>
          </li>

          <li>
            <a href="#portofolio" className="footer__link">
              Projects
            </a>
          </li>

          {/* <li>
            <a href="#testimonials" className="footer__link">
              Testimonials
            </a>
          </li> */}
        </ul>

        <div className="footer__social">
          <a
            href="https://web.facebook.com/muhammad.sony.71/"
            className="footer__social-link"
            target="_blank"
          >
            <i className="bx bxl-facebook"></i>
          </a>

          <a
            href="https://www.instagram.com/_heysonny/"
            className="footer__social-link"
            target="_blank"
          >
            <i className="bx bxl-instagram"></i>
          </a>

          <a
            href="https://www.linkedin.com/in/muhammad-sony-setiawan/"
            className="footer__social-link"
            target="_blank"
          >
            <i class="bx bxl-linkedin-square"></i>
          </a>
        </div>

        <span className="footer__copy">
          &#169; built by{" "}
          <a
            href="https://www.linkedin.com/in/muhammad-sony-setiawan/"
            target="_blank"
          >
            Muhammad Sony Setiawan
          </a>
          {/* &#169;
          Crypticalcoder. All rigths reserved */}
        </span>
      </div>
    </footer>
  );
}

export default Footer